import styled from 'styled-components';

export const Container = styled.main<{ scroll?: boolean; column?: boolean }>`
  max-height: calc(
    100vh - ${({ theme }) => theme.metrics.header_height} - ${({ theme }) => theme.metrics.margin}
  );
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  padding: ${({ theme }) => theme.metrics.padding} 10%;
  gap: ${({ theme }) => theme.metrics.gap};
  overflow: hidden;

  @media (max-width: ${({ theme }) => theme.metrics.desktop_xlarge}) {
    padding: ${({ theme }) => theme.metrics.padding};
  }

  @media (max-width: ${({ theme }) => theme.metrics.desktop_small}) {
    max-height: initial;
    flex-direction: column;
  }
`;
